import { useEffect } from "react";
import "./AboutUs.css"; // Assuming you have a CSS file for styling
import Footer from "../Footer";
import Head from "../Head";
const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="top-head-section-new"></div>
      <div className="faq-section about-us-parent">
        <div className="container">
          <div className="aboutUs-header">
            <Head />
          </div>
          <h2 className="aboutUs-heading main-container-section">About Us</h2>
          <div className="about-us">
            <h4>Welcome to LF Coin ($LAL)</h4>
            <p>
              The{" "}
              <b>
                community-driven meme coin built for sports fans and crypto
                enthusiasts alike!{" "}
              </b>
              Rooted in <b>Los Angeles sports culture</b>, $LAL was created to{" "}
              <b>unite fans in a decentralized way</b>, offering unique
              experiences, interactive games, and exclusive NFT memberships.
            </p>
            <br />
            <h4>What We Stand For</h4>
                       <div className="standfor">
                  <ul>
                    <li>
                      <b>Community Engagement:</b>&nbsp; We believe in giving power to
                    our holders, with NFT-based voting rights influencing key
                    decisions.
                    </li>
                    <li>
                      <b>Transparency & Fairness:</b>&nbsp; No hidden agendas—just a{" "}
                    <b>fun, open, and inclusive</b> space for all.
                    </li>
                    <li>
                    <b>Sports + Crypto Culture:</b> We blend{" "}
                    <b>
                      the energy of sports fandom with the creativity of
                      blockchain technology.
                    </b>
                    </li>
                  </ul>
                </div>
            <br />
            <p>
              Whether you're here to collect, trade, or just be part of
              something exciting, <b>welcome to the $LAL family! 🚀🏆</b>
            </p>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 disclouser-sec">
              <div className="lend-cont-inner-in">
                <p>
                  <strong>Disclosure:</strong> LF Coin ($LAL) is a
                  community-driven meme coin created to celebrate sports fandom
                  and foster community engagement. LF Coin is not affiliated
                  with the Los Angeles Lakers, the National Basketball
                  Association (NBA), or any associated organizations. The
                  project operates independently and is solely focused on
                  building a decentralized community of sports enthusiasts. As a
                  meme coin, LF Coin carries no intrinsic value and should not
                  be considered an investment or security.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="about-footer updated-footer">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AboutUs;
